angular.module 'memberPortal'
  .config (
    $stateProvider
  ) ->

    $stateProvider
      .state 'memberPortal.workouts',
        url: '/workouts?m'
        controller: 'WorkoutsCtrl'
        template: require('templates/member_portal/workouts/list.html.slim')
        data:
          title: 'Regular Workouts'
        resolve:
          workouts: (Restangular) ->
            Restangular.all('workouts').getList(count: 200)

      .state 'memberPortal.performWorkout',
        url: '/workouts/:id?m'
        controller: 'PerformWorkoutCtrl'
        template: require('templates/member_portal/workouts/perform.html.slim')
        data:
          title: 'Perform Workout'
        resolve:
          workout: ($stateParams, Restangular) ->
            Restangular.one('workouts', $stateParams.id).get()

      .state 'memberPortal.performedworkouts',
        url: '/performed_workouts?m'
        controller: 'PerformedWorkoutsCtrl'
        template: require('templates/member_portal/workouts/performed.html.slim')
        data:
          title: 'Completed Workouts'
